var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.95 27.121l-7.071-7.07a1 1 0 0 0-1.414 0l-.354.353-1.006-1.006.32-.321a10.3 10.3 0 1 0-1.348 1.349l.32-.321 1.007 1.006-.354.354a1 1 0 0 0 0 1.414l7.071 7.07a1 1 0 0 0 1.414 0l1.415-1.414a1 1 0 0 0 0-1.414zm-11.583-7.404a9.272 9.272 0 0 1-5.87 2.083h-.001A9.299 9.299 0 0 1 5.928 5.924a9.296 9.296 0 0 1 13.723 12.514zm9.461 9.526l-7.07-7.071 1.414-1.415 7.07 7.071z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass32);
export default __webpack_public_path__ + "static/media/magnifying-glass-32.f96d1bd5e5fff56402b4dd762b3acdff.svg";
export { ForwardRef as ReactComponent };